import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const BOLD_PLUGIN_ID = 'bold' as const;
export type BoldPluginID = typeof BOLD_PLUGIN_ID;

export type BoldPluginElement = EditorElement;

export type BoldPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
  }
>;

export type BoldPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    BoldPluginOptions & {
      pluginID: BoldPluginID;
      hotkey: string;
      icon: ComponentType<any>;
      pluginName: string;
      component: ComponentType<any>;
    }
>;
